import React, { useState, useRef, useEffect } from "react";
import arrowDown from "/arrow_dropdown_black.svg";

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps {
  name: string;
  options: Option[];
  placeholder?: string;
  disabled?: boolean;
  useFormContext: any;
  showFirstValueSeparator?: boolean;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  name,
  options,
  placeholder = "Select an option",
  disabled = false,
  useFormContext,
  showFirstValueSeparator = false,
}) => {
  const { setValue, watch, register } = useFormContext;
  const selected = watch(name);
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleSelect = (value: string) => {
    setValue(name, value);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full text-sm 2xl:text-base" ref={ref}>
      <div
        onClick={() => !disabled && setIsOpen(!isOpen)}
        className={`border h-10 2xl:h-12 border-gray-300 rounded-md p-3 pr-3 flex items-center justify-between ${
          disabled
            ? "bg-[#FAFAFA] text-slate-400 cursor-not-allowed"
            : "hover:border-blue-400 bg-white text-gray-700 cursor-pointer"
        }`}
      >
        <span
          className={`text-nowrap overflow-hidden text-xs sm:text-sm ${
            selected ? "text-gray-800" : "text-gray-400"
          } ${
            disabled || selected == null || selected == ""
              ? " text-slate-400"
              : "  text-gray-700"
          }`}
        >
          {options.find((o) => o.value === selected)?.label || placeholder}
        </span>
        <span>
          <img src={arrowDown} alt="" />
        </span>
      </div>

      {isOpen && !disabled && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg  text-gray-700">
          {options.map((option, index) => (
            <React.Fragment key={index}>
              <li
                onClick={() => handleSelect(option.value)}
                className={`py-2 hover:bg-gray-100 cursor-pointer px-3 ${
                  selected === option.value ? "bg-gray-50 font-medium" : ""
                } ${showFirstValueSeparator && index == 0 && "py-2.5"}`}
              >
                {option.label == "Select Report Type" ? "None" : option.label}
              </li>
              {showFirstValueSeparator && index == 0 && <hr />}
            </React.Fragment>
          ))}
        </ul>
      )}

      <input type="hidden" {...register(name)} />
    </div>
  );
};

export default CustomSelect;
